import { spawn } from "redux-saga/effects";

import boostrapSaga from "./bootstrap/bootstrap.saga";
import notificationsSaga from "./notifications.saga";

export default function* appSaga() {
  yield spawn(boostrapSaga);
  yield spawn(notificationsSaga);
}
